import { GlobalState } from 'reducers';

export const getAppointments = (state: GlobalState) =>
  state.appointments.normalized;
